import React from 'react';
import { Lock, Zap, Shield, FileText } from 'lucide-react';
import { Section, CTAButton, CHECKOUT_URL, PRICE_EUR, PRODUCT_NAME, SUPPORT_EMAIL, INSTAGRAM_URL } from './Shared';
const guarantees = [{
  icon: Lock,
  label: 'Pagamento sicuro'
}, {
  icon: Zap,
  label: 'Accesso immediato'
}, {
  icon: Shield,
  label: 'Garanzia di 7 giorni'
}, {
  icon: FileText,
  label: 'Materiale in PDF'
}];
export const EmotionalClose = () => <Section className="max-w-4xl" data-id="element-45" data-mp="mmg6rc9ywrl0">
    <div className="glass-panel gold-frame p-7 md:p-14 rounded-sm text-center" data-id="element-46" data-mp="mjbt7oam4jho">
      <h2 className="text-2xl md:text-4xl font-display font-bold mb-3 text-brand-purpleDark leading-tight" data-id="element-47" data-mp="hlaa53d6sk67">
        Una scelta semplice per lavorare con più continuità.
      </h2>

      <div className="gold-rule my-7" aria-hidden="true" data-id="element-48" data-mp="7ppavczi5y05">
        <span className="text-brand-gold text-[10px]" data-id="element-49" data-mp="2719rv8uvfhxg">◆</span>
      </div>

      <div className="space-y-5 text-base md:text-lg text-brand-text/85 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-50" data-mp="26z5ocs0vwkxp">
        <p data-id="element-51" data-mp="352ixayp8mdxt">
          Non hai bisogno di accumulare altri esercizi senza un criterio. Hai
          bisogno di sapere come ordinarli, come presentarli e come adattarli
          all’interno di una lezione comprensibile.
        </p>
        <p className="text-brand-purpleDark font-medium" data-id="element-52" data-mp="2v5ei5itt7iqi">
          Il {PRODUCT_NAME} è stato creato per aiutarti a trasformare il tuo
          bagaglio di conoscenze in un metodo di lavoro più ordinato, chiaro e
          sostenibile.
        </p>
        <p className="font-display italic text-lg md:text-xl text-brand-goldDark" data-id="element-53" data-mp="3nvczst5ocdl5">
          La tua pratica merita una struttura all’altezza della tua esperienza.
        </p>
      </div>

      <div className="max-w-md mx-auto mb-10" data-id="element-54" data-mp="3e14kx89kgj5g">
        <div className="border border-brand-purpleDark/15 bg-brand-surfaceLight/40 rounded-sm p-7 text-center flex flex-col relative" data-id="element-55" data-mp="3j1scpw5md40q">
          <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-brand-purpleDark text-brand-goldLight font-seal text-[11px] uppercase tracking-seal px-3 py-1" data-id="element-56" data-mp="akxjl8emixzu">
            Inizia da qui
          </span>
          <h3 className="font-display font-bold text-xl text-brand-purpleDark mb-2 mt-3" data-id="element-57" data-mp="p7386dhn7n1p">
            {PRODUCT_NAME}
          </h3>
          <p className="font-display font-bold text-4xl text-brand-purpleDark" data-id="element-58" data-mp="g892zyq8xocj">
            {PRICE_EUR}
          </p>
          <p className="text-xs text-brand-muted mt-2 mb-4" data-id="element-59" data-mp="ba7lvjcdrz3p">
            Pagamento unico · Accesso immediato dopo l’acquisto
          </p>
          <p className="text-sm text-brand-text/75 mb-6" data-id="element-60" data-mp="6bmixc5qv1bk">
            3 volumi principali + 5 bonus pratici · Oltre 300 pagine per
            progettare, insegnare e adattare le tue lezioni di Qi Gong.
          </p>
          <CTAButton fullWidth className="text-xs md:text-sm py-4" href={CHECKOUT_URL} variant="purple" data-id="element-61" data-mp="3snjqxcjke71e">
            Voglio il Mega Pack Qi Gong — {PRICE_EUR}
          </CTAButton>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs md:text-sm text-brand-muted mb-10" data-id="element-62" data-mp="3jr2dg2nq9x2h">
        {guarantees.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center" data-id="element-63" data-mp="1ua6xkkm6w5h3">
            <Icon className="w-4 h-4 mr-1.5 text-brand-gold" data-id="element-64" data-mp="1z5vv6ienfcar" /> {label}
          </span>)}
      </div>

      <div className="text-sm text-brand-text/85 border-t border-brand-gold/30 pt-7 space-y-3 max-w-2xl mx-auto" data-id="element-65" data-mp="247l9c6x64632">
        <p data-id="element-66" data-mp="2872gr5w5ndav">
          <strong className="text-brand-purpleDark" data-id="element-67" data-mp="285rb10j5fvh4">Hai bisogno di aiuto?</strong>{' '}
          Scrivici prima o dopo l’acquisto a{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-brand-goldDark hover:underline font-medium break-all" data-id="element-68" data-mp="1gg6528ltzep6">
            {SUPPORT_EMAIL}
          </a>{' '}
          oppure su{' '}
          <a href={INSTAGRAM_URL} className="text-brand-goldDark hover:underline font-medium" data-id="element-69" data-mp="1p8ra6lwjhmvj">
            @Lumen_Akasha
          </a>
          . Risponderemo nel più breve tempo possibile.
        </p>
        <p className="font-display italic text-brand-goldDark text-base" data-id="element-70" data-mp="wsggea96xuk6">
          Comincia oggi a preparare le tue lezioni con maggiore sicurezza.
        </p>
      </div>
    </div>
  </Section>;